// extracted by mini-css-extract-plugin
export default {"commentsCard":"comments_commentsCard__6jnzC","greyLabel":"comments_greyLabel__7cud+","commentText":"comments_commentText__+46tv"};